import { render, staticRenderFns } from "./downIcon.vue?vue&type=template&id=8f585ad2"
import script from "./downIcon.vue?vue&type=script&lang=js"
export * from "./downIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports